import { ImageType } from '../../SellTrade/types/SellTradeForm.types';

export type CallbackType = {
  entityId: string | null;
  entityType: CallbackEntityEnum;
  email: string | null;
  phone: string | null;
  phoneCode: string;
  name: string;
  comment: string;
  images: ImageType[];
  serviceType: string;
  price: string;
  serviceTypeEnum: OrderServiceTypeEnum | null;
};

export enum CallbackEntityEnum {
  Product,
  Service,
}

export enum OrderServiceTypeEnum {
  Business,
  Premium,
  Exclusive,
}
